module.exports = __webpack_public_path__ + "img/ec1bba9.jpg";